import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';

import AppMenuItem from './AppMenuItem';
import dashboardIcon from '../../../public/assets/img/Dashboard.svg';
import OrdersIcon from '../../../public/assets/img/orders.svg';
import StoresIcon from '../../../public/assets/img/stores.svg';
import PaymentIcon from '../../../public/assets/img/payments.svg';
import badgeCheck from '../../../public/assets/img/badgeCheck.svg';
import createAccount from '../../../public/assets/img/createAccount.svg';
import settingsIcon from '../../../public/assets/img/utility-settings.svg';
import logoutIcon from '../../../public/assets/img/action-log-out.svg';
import userAddIcon from '../../../public/assets/img/user-plus.svg';
import {
  AGGREGRATOR_TEXT,
  CREATEACCOUNTS_TEXT,
  HOME_TEXT,
  MENU_LOGOUT_TEXT,
  MENU_ORDER_TEXT,
  MENU_PAYMENTS_TEXT,
  MENU_SETTINGS_TEXT,
  MENU_STORE_TEXT,
  MERCHANT_TEXT,MERCHANTACC_TEXT,MANAGEMERCHANT_TEXT,ADMINACCOUNT_TEXT
} from '../../constants/DashboardConstants';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAdminSaga } from '../../redux/saga/loginServiceSelector';
import { selectedStoreSelectorSaga } from '../../redux/saga/storePageSelectors';

const AppMenu = ({ logoutHandle }) => {
  const [selectedNavIndex, setSelectedNavIndex] = useState(0);
  const { pathname, state } = useLocation();
  let adminFlow = useSelector(isAdminSaga);
  const [appMenuItems, setAppMenuItems] = useState([]);
  const selectedStoreSelector = useSelector(selectedStoreSelectorSaga);
  const enableBizDev = process.env.REACT_APP_ENABLE_BIZDEV === 'true';
  const enablepaymentsTab = process.env.REACT_APP_ENABLE_PAYMENTS_TAB === 'true';
  
  useEffect(() => {
    // console.log('ADMIN ',adminFlow, sessionStorage.getItem('isAdmin'))
    setAppMenuItems(
      (adminFlow || sessionStorage.getItem('isAdmin') === 'true')
        ? [
            {
              name: HOME_TEXT,
              link: '/dashboard/adminhomepage',
              Icon: dashboardIcon,
              classnameprops: 'menu-items-list',
              navIndex: 0,
            },
			...(enableBizDev ? [{
				name: 'Onboard Business',
				link: '/dashboard/onboardbusiness',
				Icon: StoresIcon,
				classnameprops: 'menu-items-list',
				navIndex: 1,
				}] : []),
            {
              name: CREATEACCOUNTS_TEXT,
              Icon: userAddIcon,
              navIndex: 2,
              items: [
                {
                  name: MERCHANTACC_TEXT,
				  link: '/dashboard/createmerchant',
                  classnameprops: 'menu-items-list',
                  navIndex: 3,
                },
                {
                  name: ADMINACCOUNT_TEXT,
				  link: '/dashboard/createadmin',
                  classnameprops: 'menu-items-list',
                  navIndex: 4,
                },
              ],
              classnameprops: 'menu-items-list',
            },
            {
              name: MANAGEMERCHANT_TEXT,
			  link: '/dashboard/managemerchants',
              Icon: StoresIcon,
			  classnameprops: 'menu-items-list',
              navIndex: 5,
            },
            {
              name: MENU_LOGOUT_TEXT,
              link: '/',
              Icon: logoutIcon,
              classnameprops: 'menu-items-list logout-child',
              navIndex: 6,
            },
          ]
        : [
            {
              name: MENU_ORDER_TEXT,
              link: '/dashboard/orders',
              Icon: OrdersIcon,
              classnameprops: 'menu-items-list',
              navIndex: 0,
            },
            {
              name: MENU_STORE_TEXT,
              link: '/dashboard/stores',
              Icon: StoresIcon,
              classnameprops: 'menu-items-list',
              navIndex: 1,
            },
			...(enablepaymentsTab ? [{
				name: MENU_PAYMENTS_TEXT,
				link: '/dashboard/payments',
				Icon: PaymentIcon,
				classnameprops: 'menu-items-list',
				navIndex: 2,
				}] : []),
            {
              name: MENU_SETTINGS_TEXT,
              link: '/dashboard/settings',
              Icon: settingsIcon,
              classnameprops: 'menu-items-list settings-child',
              navIndex: 3,
            },
            {
              name: MENU_LOGOUT_TEXT,
              link: '/',
              Icon: logoutIcon,
              classnameprops: 'menu-items-list logout-child',
              navIndex: 4,
            },
          ]
    );
  }, [adminFlow]);

  useEffect(() => {
    if (appMenuItems.length > 0) {
      appMenuItems.forEach((nav) => {
        if (nav?.link === pathname) {
          if (pathname === '/dashboard/stores' && selectedStoreSelector && selectedStoreSelector?.storeId && selectedStoreSelector?.storeUUID) {
            setSelectedNavIndex(1);
          } else {
            setSelectedNavIndex(nav?.navIndex);
          }
        } else if (pathname === '/dashboard/activation') {
          setSelectedNavIndex(3);
        } else if (pathname === '/dashboard/createadmin') {
          setSelectedNavIndex(4);
        } else if (pathname === '/dashboard/createmerchant') {
			setSelectedNavIndex(3);
		} else if (pathname.startsWith('/dashboard/stores/singlestoreview/')) {
          setSelectedNavIndex(1);
        }
		if (nav?.name === CREATEACCOUNTS_TEXT) { // this to set parent menu item as active
			nav.items?.forEach((child) => {
			  if (child.link === pathname) {
				setSelectedNavIndex(nav?.navIndex); 
			  }
			});
		  }
      });
    }
  }, [pathname, appMenuItems, selectedStoreSelector]);

  return (
    <List component='nav' disablePadding className={(adminFlow || sessionStorage.getItem('isAdmin') === 'true') ? 'nav-admin-menu-items' : 'nav-menu-items'} data-testid='app-menu-id'>
      {appMenuItems.map((item, index) => (
        <AppMenuItem {...item} key={index} setSelectedNavIndex={(item) => setSelectedNavIndex(item)} selectedNavIndex={selectedNavIndex} logoutHandle={() => logoutHandle()} />
      ))}
    </List>
  );
};

export default AppMenu;
